import React from 'react';
import TextField from "@components/TextField";
import AutoCompleteField from "@components/AutoCompleteV2";
import Checkbox from "@components/CheckBox";
import Input from "@components/Input";
import TextArea from "@components/TextArea";
import { MdDocumentScanner } from 'react-icons/md';
import './HeaderForm.css';

const HeaderForm = ({ 
  doctype, 
  date, 
  idprovider, 
  providers, 
  automation, 
  automations, 
  doc, 
  fakeIdordersource, 
  filteredOrders, 
  indif, 
  idposto, 
  warehouses,
  obs,
  handleChange, 
  handleInitialize, 
  handleFinalize, 
  handleEnter, 
  handleCheckboxChange, 
  validForm
}) => {
  return (
    <>
      <div style={{
      background: '#ffffff',
      border: '1px solid #e2e8f0',
      padding: '32px',
      borderRadius: '24px',
      boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      
      {/* Header title */}
      <div style={{
        position: 'relative',
        zIndex: 1,
        marginBottom: '28px',
        textAlign: 'center'
      }}>
        <h2 className="header-title">
          <MdDocumentScanner className="header-icon" />
          <span className="header-text">
            Cabeçalho do Documento
          </span>
        </h2>
        <div style={{
          width: '60px',
          height: '3px',
          background: '#e5e7eb',
          margin: '12px auto 0',
          borderRadius: '2px'
        }} />
      </div>

      <div style={{ 
        position: 'relative',
        zIndex: 1,
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
        margin: 0
      }}>
        {doctype.headers.map((header) => {
          switch (header) {
            case 'data':
            case '#data':
              return (
                <div key={header} style={{
                  background: '#ffffff',
                  padding: '20px',
                  borderRadius: '16px',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  transition: 'all 0.3s ease'
                }}>
                  <TextField
                    type="date"
                    name="date"
                    label="Data"
                    value={date}
                    readOnly={header === '#data'}
                    onChange={header === '#data' ? undefined : (e) => {
                      handleChange(e);
                    }}
                  />
                </div>
              );
            case 'datahora':
            case '#datahora':
              return (
                <div key={header} style={{
                  background: '#ffffff',
                  padding: '20px',
                  borderRadius: '16px',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  transition: 'all 0.3s ease'
                }}>
                  <TextField
                    type="datetime-local"
                    name="date"
                    label="Data e Hora"
                    value={date}
                    readOnly={header === '#datahora'}
                    onChange={header === '#datahora' ? undefined : (e) => {
                      handleChange(e);
                    }}
                  />
                </div>
              );
            case 'provider':
            case '#provider':
              return (
                <div key={header} style={{
                  background: '#ffffff',
                  padding: '20px',
                  borderRadius: '16px',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  transition: 'all 0.3s ease'
                }}>
                  <AutoCompleteField
                    options={providers}
                    value={idprovider}
                    readOnly={!indif && validForm()}
                    onChange={!indif && validForm() ? undefined : (_, provider) => {
                      handleChange({
                        target: {
                          name: "idprovider",
                          value: provider
                        }
                      });
                    }}
                    getOptionLabel={(option) => option.label || ""}
                    label="Fornecedor"
                  />
                </div>
              );
            case 'automation':
            case '#automation':
              return (
                <div key={header} style={{
                  background: '#ffffff',
                  padding: '20px',
                  borderRadius: '16px',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  transition: 'all 0.3s ease'
                }}>
                  <AutoCompleteField
                    options={automations}
                    value={automation}
                    readOnly={header === '#automation'}
                    onChange={header === '#automation' ? undefined : (_, automation) => {
                      handleChange({
                        target: {
                          name: "automation",
                          value: automation
                        }
                      });
                    }}
                    getOptionLabel={(option) => option.label || ""}
                    label="Criação"
                  />
                </div>
              );
            case 'doc':
            case '#doc':
              return (
                <div key={header} style={{
                  background: '#ffffff',
                  padding: '20px',
                  borderRadius: '16px',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  transition: 'all 0.3s ease'
                }}>
                  <Input
                        inputType={"text"}
                        name={"doc"}
                        value={doc}
                        readOnly={header === '#doc'}
                        handleChange={header === '#doc' ? undefined : handleChange}
                        onFocus={header === '#doc' ? undefined : handleInitialize}
                        onBlur={header === '#doc' ? undefined : handleFinalize}
                        onKeyPress={header === '#doc' ? undefined : handleEnter}
                    />
                </div>
              );
            case 'order':
            case '#order':
              return (
                <div key={header} style={{
                  background: '#ffffff',
                  padding: '20px',
                  borderRadius: '16px',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  transition: 'all 0.3s ease'
                }}>
                  {!indif && <div data-field-name="idordersource">
                    <AutoCompleteField
                      options={filteredOrders}
                      value={fakeIdordersource}
                      readOnly={header === '#order'}
                      onChange={header === '#order' ? undefined : (_, order) => {
                        handleChange({
                          target: {
                            name: "idordersource",
                            value: order
                          }
                        });
                      }}
                      getOptionLabel={(option) => option.label || ""}
                      label="Compra"
                    />
                  </div>}
                  {indif && (
                    <div style={{
                      padding: '12px 16px',
                      background: '#f8fafc',
                      borderRadius: '12px',
                      border: '1px solid #e2e8f0',
                      textAlign: 'center',
                      fontSize: '16px',
                      fontWeight: '500',
                      color: '#475569'
                    }}>
                      Compra Indiferenciada
                    </div>
                  )}
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    marginTop: '16px',
                    padding: '12px',
                    background: '#f8fafc',
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0'
                  }}>
                    <Checkbox
                      position={"left"}
                      name={"indif"}
                      checked={indif}
                      readOnly={header === '#order'}
                      handleChange={header === '#order' ? undefined : handleCheckboxChange}
                    />
                    <div style={{
                      marginLeft: '8px',
                      fontSize: '14px',
                      fontWeight: '500',
                      color: '#374151'
                    }}>
                      Indiferenciado
                    </div>
                  </div>
                </div>
              );
            case 'idposto':
            case '#idposto':
              return (
                <div key={header} style={{
                  background: '#ffffff',
                  padding: '20px',
                  borderRadius: '16px',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  transition: 'all 0.3s ease'
                }}>
                  <AutoCompleteField
                    options={warehouses}
                    value={idposto}
                    readOnly={header === '#idposto'}
                    onChange={header === '#idposto' ? undefined : (_, posto) => {
                      handleChange({
                        target: {
                          name: "idposto",
                          value: posto
                        }
                      });
                    }}
                    getOptionLabel={(option) => option.label || ""}
                    label="Posto"
                  />
                </div>
              );
            case 'obs':
            case '#obs':
              return (
                <div key={header} style={{
                  background: '#ffffff',
                  padding: '20px',
                  borderRadius: '16px',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  transition: 'all 0.3s ease',
                  gridColumn: '1 / -1'
                }}>
                  <TextArea
                    name="obs"
                    label="Observações"
                    value={obs || ''}
                    readOnly={header === '#obs'}
                    handleChange={header === '#obs' ? undefined : handleChange}
                    rows={3}
                  />
                </div>
              );
            default:
              return null;
          }
        })}
      </div>
    </div>
    </>
  );
};

export default HeaderForm;
